import { ApolloError, useQuery } from '@apollo/client'
import { EmployeeWithAppraisalInviteInfoQuery, EmployeeWithAppraisalInviteInfoQueryVariables } from '../../../types'
import { EMPLOYEE_WITH_APPRAISAL_INVITE_INFO } from '../../invite-options/inviteOptions'

export const useEmployeeWithAppraisalInviteInfo = (
  employeeId: string,
): { data: EmployeeWithAppraisalInviteInfoQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<EmployeeWithAppraisalInviteInfoQuery, EmployeeWithAppraisalInviteInfoQueryVariables>(
    EMPLOYEE_WITH_APPRAISAL_INVITE_INFO,
    {
      variables: { employeeId },
      fetchPolicy: 'network-only',
    },
  )

  return { data, error, loading }
}
